<template>
  <div class="app-wrapper">
    <!-- 侧边栏 -->
    <div class="sidebar">
      <!-- 添加Logo -->
      <div class="logo-container">
        <router-link to="/welcome">
          <img src="@/assets/images/logo/oier-icon.svg" alt="OIer之路" class="logo-img" title="OIer之路" />
        </router-link>
      </div>
      
      <el-menu
        :default-active="$route.path"
        router
        :collapse="false"
        :collapse-transition="false"
        class="vertical-menu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#eeba4c">
        <el-menu-item index="/welcome" class="menu-item-vertical">
          <div class="menu-icon-container">
            <i class="el-icon-menu"></i>
            <span slot="title">首页</span>
          </div>
        </el-menu-item>
        
        <!-- 数据菜单改为二级菜单 -->
        <div class="custom-submenu" data-menu="analysis" :class="{'active-parent': isParentActive('analysis')}">
          <div class="menu-item-vertical" 
               @mouseenter="showSubmenu('analysis')" 
               @mouseleave="hideSubmenuWithDelay('analysis')">
            <div class="menu-icon-container" :class="{'active-menu': isParentActive('analysis')}">
              <i class="el-icon-data-line"></i>
              <span>数据</span>
            </div>
          </div>
          <div class="custom-submenu-dropdown" 
               v-show="activeSubmenu === 'analysis'"
               @mouseenter="cancelHideSubmenu"
               @mouseleave="hideSubmenu">
            <el-menu-item index="/analysis/panel" @click.native="handleMenuItemClick('/analysis/panel')" class="left-aligned-menu-item">
              <div class="menu-item-content">
                <i class="el-icon-data-analysis"></i>
                <span>数据面板</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/analysis/monthly" @click.native="handleMenuItemClick('/analysis/monthly')" class="left-aligned-menu-item">
              <div class="menu-item-content">
                <i class="el-icon-data-analysis"></i>
                <span>月度环比</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/analysis/wrong-analysis" @click.native="handleMenuItemClick('/analysis/wrong-analysis')" class="left-aligned-menu-item">
              <div class="menu-item-content">
                <i class="el-icon-warning"></i>
                <span>错题分析</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/analysis/correction-analysis" @click.native="handleMenuItemClick('/analysis/correction-analysis')" class="left-aligned-menu-item">
              <div class="menu-item-content">
                <i class="el-icon-edit"></i>
                <span>订正分析</span>
              </div>
            </el-menu-item>
          </div>
        </div>
        
        <el-menu-item index="/game" class="menu-item-vertical">
          <div class="menu-icon-container">
            <i class="el-icon-trophy"></i>
            <span slot="title">赛事</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/question" class="menu-item-vertical">
          <div class="menu-icon-container">
            <i class="el-icon-document-checked"></i>
            <span slot="title">题目</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/wrongbook" class="menu-item-vertical">
          <div class="menu-icon-container">
            <i class="el-icon-edit-outline"></i>
            <span slot="title">错题</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/tag" class="menu-item-vertical">
          <div class="menu-icon-container">
            <i class="el-icon-collection-tag"></i>
            <span slot="title">标签</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/outline" class="menu-item-vertical">
          <div class="menu-icon-container">
            <i class="el-icon-notebook-2"></i>
            <span slot="title">大纲</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/plan" class="menu-item-vertical">
          <div class="menu-icon-container">
            <i class="el-icon-time"></i>
            <span slot="title">计划</span>
          </div>
        </el-menu-item>
        
        <!-- 文章菜单改为二级菜单 -->
        <div class="custom-submenu" data-menu="article" :class="{'active-parent': isParentActive('article')}">
          <div class="menu-item-vertical" 
               @mouseenter="showSubmenu('article')" 
               @mouseleave="hideSubmenuWithDelay('article')">
            <div class="menu-icon-container" :class="{'active-menu': isParentActive('article')}">
              <i class="el-icon-reading"></i>
              <span>文章</span>
            </div>
          </div>
          <div class="custom-submenu-dropdown" 
               v-show="activeSubmenu === 'article'"
               @mouseenter="cancelHideSubmenu"
               @mouseleave="hideSubmenu">
            <el-menu-item index="/article" @click.native="handleMenuItemClick('/article')" class="left-aligned-menu-item">
              <div class="menu-item-content">
                <i class="el-icon-document"></i>
                <span>管理</span>
              </div>
            </el-menu-item>
            <div class="left-aligned-menu-item blog-link-item" @click="openBlogInNewTab">
              <div class="menu-item-content">
                <i class="el-icon-notebook-1"></i>
                <span>博客</span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 管理菜单 -->
        <div class="custom-submenu" data-menu="system" :class="{'active-parent': isParentActive('system')}">
          <div class="menu-item-vertical" 
               @mouseenter="showSubmenu('system')" 
               @mouseleave="hideSubmenuWithDelay('system')">
            <div class="menu-icon-container" :class="{'active-menu': isParentActive('system')}">
              <i class="el-icon-setting"></i>
              <span>管理</span>
            </div>
          </div>
          <div class="custom-submenu-dropdown" 
               v-show="activeSubmenu === 'system'"
               @mouseenter="cancelHideSubmenu"
               @mouseleave="hideSubmenu">
            <el-menu-item index="/system/friend-link" @click.native="handleMenuItemClick('/system/friend-link')" class="left-aligned-menu-item">
              <div class="menu-item-content">
                <i class="el-icon-link"></i>
                <span>友链管理</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/system/dict" @click.native="handleMenuItemClick('/system/dict')" class="left-aligned-menu-item">
              <div class="menu-item-content">
                <i class="el-icon-collection"></i>
                <span>字典管理</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/system/user" @click.native="handleMenuItemClick('/system/user')" class="left-aligned-menu-item">
              <div class="menu-item-content">
                <i class="el-icon-user"></i>
                <span>用户管理</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/system/great-event" @click.native="handleMenuItemClick('/system/great-event')" class="left-aligned-menu-item">
              <div class="menu-item-content">
                <i class="el-icon-star-on"></i>
                <span>大事记管理</span>
              </div>
            </el-menu-item>
          </div>
        </div>
      </el-menu>
      
      <!-- 底部用户信息和退出按钮 -->
      <div class="bottom-container">
        <div class="bottom-buttons">
          <!-- 添加用户头像，鼠标悬停显示用户名和积分，点击编辑个人信息 -->
          <el-tooltip placement="right" effect="dark" popper-class="custom-user-tooltip">
            <div slot="content">
              <div class="user-tooltip-content">
                <div class="username">{{ username || '未登录' }}</div>
                <div class="score-info" @click="handleViewScore">
                  <div class="score-content">
                    <span class="infinity-icon">🧑‍💻</span>
                    <span class="score-value clickable">{{ userScore }}</span>
                    <span class="score-label">积分</span>
                  </div>
                  <div class="click-hint">点击查看详情</div>
                </div>
              </div>
            </div>
            <div class="avatar" @click="handleEditProfile">{{ getFirstChar }}</div>
          </el-tooltip>
          <el-tooltip content="退出登录" placement="right">
            <div class="logout-btn" @click="handleLogout">
              <i class="el-icon-switch-button"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>

    <!-- 主要内容区 -->
    <div class="main-container">
      <div class="content-wrapper">
        <router-view></router-view>
      </div>
    </div>

    <!-- 赛博按钮 -->
    <CyberButton />

    <!-- 积分详情对话框 -->
    <el-dialog
      title="积分详情"
      :visible.sync="scoreDialogVisible"
      width="600px"
      center
      :close-on-click-modal="false"
      append-to-body
      custom-class="score-dialog">
      <div v-if="currentUserScore" class="score-detail">
        <div class="user-info">
          <h3>
            {{ currentUserScore.name }} ({{ currentUserScore.username }})
            <el-button 
              type="text" 
              icon="el-icon-data-analysis"
              @click="handleScoreTrend"
              style="margin-left: 10px; color: #409EFF;">
              积分分析
            </el-button>
          </h3>
        </div>
        
        <el-divider></el-divider>
        
        <div class="score-breakdown">
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-trophy"></i>
              参赛积分
            </div>
            <div class="score-value">{{ currentUserScore.game_score || 0 }}</div>
            <div class="score-desc">每参加一场比赛积分+1</div>
          </div>
          
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-check"></i>
              题目积分
            </div>
            <div class="score-value">{{ currentUserScore.question_score || 0 }}</div>
            <div class="score-desc">每AC一道题积分+1，AK额外+5</div>
          </div>
          
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-medal"></i>
              排名积分
            </div>
            <div class="score-value">{{ currentUserScore.rank_score || 0 }}</div>
            <div class="score-desc">前10%+1，前5%+2，前1%+3，第一名+5</div>
          </div>
          
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-edit"></i>
              订正积分
            </div>
            <div class="score-value">{{ currentUserScore.fix_score || 0 }}</div>
            <div class="score-desc">每订正一道题积分+1</div>
          </div>
          
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-video-camera"></i>
              复盘积分
            </div>
            <div class="score-value">{{ currentUserScore.replay_score || 0 }}</div>
            <div class="score-desc">每复盘一场比赛积分+2</div>
          </div>
          
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-document"></i>
              文章积分
            </div>
            <div class="score-value">{{ currentUserScore.article_score || 0 }}</div>
            <div class="score-desc">每一篇文章积分+2</div>
          </div>
        </div>
        
        <el-divider></el-divider>
        
        <div class="total-score">
          <div class="total-label">总积分</div>
          <div class="total-value">{{ currentUserScore.total_score || 0 }}</div>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="scoreDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import CyberButton from '@/components/CyberButton.vue'

export default {
  name: 'Layout',
  components: {
    CyberButton
  },
  data() {
    return {
      username: '',
      userScore: 0, // 用户积分
      activeSubmenu: null,
      hideSubmenuTimer: null,
      // 积分详情相关数据
      scoreDialogVisible: false,
      currentUserScore: null,
      // 定义二级菜单路径映射关系
      menuPathMap: {
        'analysis': ['/analysis/panel', '/analysis/monthly', '/analysis/wrong-analysis'],
        'system': ['/system/friend-link', '/system/dict', '/system/user', '/system/great-event'],
        'article': ['/article', '/blog']
      }
    }
  },
  computed: {
    getFirstChar() {
      if (!this.username) return '?'
      
      // 移除所有空格
      const name = this.username.trim()
      
      // 如果是空字符串
      if (name.length === 0) return '?'
      
      // 判断是否包含中文
      const hasChinese = /[\u4e00-\u9fa5]/.test(name)
      
      if (!hasChinese) {
        // 如果是英文，返回第一个字母大写
        return name.charAt(0).toUpperCase()
      }
      
      // 提取所有中文字符
      const chineseChars = name.match(/[\u4e00-\u9fa5]/g)
      if (!chineseChars) return name.charAt(0)
      
      // 根据中文字数选择字符
      switch (chineseChars.length) {
        case 1:
          return chineseChars[0]
        case 2:
          return chineseChars[1] // 两个字选第二个
        case 3:
          return chineseChars[1] // 三个字选中间的
        case 4:
          return chineseChars[3] // 四个字选最后一个
        default:
          return chineseChars[0] // 其他情况选第一个
      }
    }
  },
  created() {
    this.loadUserInfo()
  },
  methods: {
    // 加载用户信息
    async loadUserInfo() {
      try {
        // 并行获取用户基本信息和积分信息
        const [userResponse, scoreResponse] = await Promise.all([
          request({
            url: '/api/user/info',
            method: 'get'
          }),
          request({
            url: '/api/user/score',
            method: 'get'
          })
        ])
        
        if (userResponse.code === 200) {
          this.currentUserInfo = userResponse.data
          this.username = userResponse.data.name || ''
          
          // 获取当前用户的积分信息
          if (scoreResponse.code === 200) {
            const scoreList = scoreResponse.data.items || []
            const currentUserScore = scoreList.find(score => score.username === userResponse.data.username)
            if (currentUserScore) {
              this.userScore = currentUserScore.total_score || 0
              // 保存完整的积分数据用于详情对话框
              this.currentUserScore = {
                ...currentUserScore,
                name: userResponse.data.name,
                username: userResponse.data.username
              }
            } else {
              this.userScore = 0
              this.currentUserScore = null
            }
          } else {
            console.warn('获取积分数据失败:', scoreResponse.message)
            this.userScore = 0
            this.currentUserScore = null
          }
          
          // 更新本地存储
          const userInfo = {
            id: userResponse.data.id,
            username: userResponse.data.username,
            name: userResponse.data.name,
            sex: userResponse.data.sex,
            birthday: userResponse.data.birthday,
            total_score: this.userScore
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
        }
      } catch (error) {
        console.error('加载用户信息失败:', error)
        // 如果API失败，尝试从本地存储获取
        const userInfo = localStorage.getItem('userInfo')
        if (userInfo) {
          const userData = JSON.parse(userInfo)
          this.currentUserInfo = userData
          this.username = userData.name || ''
          this.userScore = userData.total_score || 0
        }
      }
    },
    
    // 编辑个人信息
    handleEditProfile() {
      // 调用父组件 App.vue 的方法
      if (this.$parent && this.$parent.handleEditProfile) {
        this.$parent.handleEditProfile()
      }
    },
    
    handleLogout() {
      this.$confirm('确认退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        this.$router.push('/login')
      }).catch(() => {})
    },
    // 在新标签页中打开博客链接
    openBlogInNewTab() {
      const url = `${window.location.origin}/blog`;
      window.open(url, '_blank');
    },
    
    showSubmenu(submenu) {
      this.cancelHideSubmenu();
      this.activeSubmenu = submenu;
      
      // 在下一个DOM更新周期后设置子菜单位置
      this.$nextTick(() => {
        const parentElement = document.querySelector(`.custom-submenu[data-menu="${submenu}"] .menu-item-vertical`);
        const dropdownElement = document.querySelector(`.custom-submenu[data-menu="${submenu}"] .custom-submenu-dropdown`);
        
        if (parentElement && dropdownElement) {
          const rect = parentElement.getBoundingClientRect();
          
          // 设置子菜单位置，使其靠左对齐
          dropdownElement.style.position = 'fixed';
          dropdownElement.style.top = `${rect.top}px`;
          dropdownElement.style.left = '80px';
          dropdownElement.style.marginLeft = '0';
          dropdownElement.style.zIndex = '9999';
        }
      });
    },
    hideSubmenuWithDelay(submenu) {
      // 只有当前显示的是这个子菜单时才设置定时器
      if (this.activeSubmenu === submenu) {
        this.hideSubmenuTimer = setTimeout(() => {
          this.activeSubmenu = null;
        }, 300);
      }
    },
    hideSubmenu() {
      this.hideSubmenuTimer = setTimeout(() => {
        this.activeSubmenu = null;
      }, 300);
    },
    cancelHideSubmenu() {
      if (this.hideSubmenuTimer) {
        clearTimeout(this.hideSubmenuTimer);
        this.hideSubmenuTimer = null;
      }
    },
    handleMenuItemClick(path) {
      this.activeSubmenu = null;
      this.$router.push(path);
    },
    isParentActive(menuKey) {
      // 检查当前路由是否属于指定的父级菜单
      const currentPath = this.$route.path;
      return this.menuPathMap[menuKey] && this.menuPathMap[menuKey].some(path => currentPath.startsWith(path));
    },
    
    // 查看积分详情
    handleViewScore() {
      if (this.currentUserScore) {
        this.scoreDialogVisible = true
      } else {
        this.$message.warning('暂无积分数据')
      }
    },
    
    // 跳转到积分趋势分析
    handleScoreTrend() {
      this.$router.push({
        path: '/analysis/score-trend',
        query: {
          username: this.currentUserScore.username,
          name: this.currentUserScore.name
        }
      })
      this.scoreDialogVisible = false
    }
  },
  mounted() {
    // 移除之前的mouseenter事件处理
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  min-height: 100vh;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden; /* 防止整体出现滚动条 */
  background-color: #f0f2f5; /* 恢复为灰色背景 */
  
  // 侧边栏样式
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 70px;
    background-color: #304156;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.15);
    
    /* Logo样式 */
    .logo-container {
      width: 70px;
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), transparent);
      
      a {
        display: block;
        text-align: center;
      }
      
      .logo-img {
        width: 70px;
        height: 70px;
        transition: all 0.3s ease;
        filter: drop-shadow(0 0 5px rgba(238, 186, 76, 0.4));
        
        &:hover {
          transform: scale(1.08);
          filter: drop-shadow(0 0 8px rgba(238, 186, 76, 0.6));
        }
      }
    }
    
    .el-menu {
      border-right: none;
      flex: 1;
      overflow-y: auto;
      width: 70px !important;
      
      &.vertical-menu {
        .el-menu-item, .el-submenu__title {
          height: auto !important;
          line-height: normal !important;
          text-align: center;
          padding: 10px 0 !important;
          
          i {
            margin-right: 0 !important;
          }
          
          .menu-icon-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            
            i {
              font-size: 20px;
              margin-bottom: 5px;
            }
            
            span {
              display: block !important;
              font-size: 12px;
              line-height: 1.2;
              height: auto !important;
              width: 100%;
              text-align: center;
              white-space: normal;
              padding: 0 3px;
            }
          }
        }
        
        // 使二级菜单点击后在右侧弹出
        .el-submenu {
          &.is-opened > .el-submenu__title .el-submenu__icon-arrow {
            transform: rotateZ(180deg) !important;
          }
          
          // 使用鼠标悬停显示二级菜单，而不是点击
          &:hover > .el-menu {
            display: block !important;
          }
          
          & > .el-menu {
            display: none;
            background-color: #1f2d3d !important;
            position: fixed !important;
            left: 80px !important;
            margin-left: 0 !important;
            padding: 5px 0 !important;
            min-width: 150px !important;
            border-radius: 4px !important;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
            
            &::before {
              content: '';
              position: absolute;
              left: -5px;
              top: 20px;
              border-top: 5px solid transparent;
              border-right: 5px solid #1f2d3d;
              border-bottom: 5px solid transparent;
            }
            
            .el-menu-item {
              height: 40px !important;
              line-height: 40px !important;
              text-align: left !important;
              padding: 0 15px !important;
              
              span {
                display: inline-block !important;
                font-size: 14px !important;
                line-height: 40px !important;
              }
              
              i {
                margin-right: 5px !important;
              }
            }
          }
        }
      }
      
      // 一级菜单垂直布局样式
      .menu-item-vertical {
        height: 70px !important;
        min-height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 0 !important;
        position: relative;
        
        .menu-icon-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 0;
          height: 100%;
          transition: all 0.3s ease;
          
          i {
            margin-right: 0;
            margin-bottom: 5px;
            font-size: 20px;
            transition: all 0.3s ease;
          }
          
          span {
            display: block !important;
            font-size: 12px;
            line-height: 1.2;
            padding: 0 3px;
            white-space: normal;
            transition: all 0.3s ease;
          }
        }
        
        &:hover {
          background-color: rgba(255, 255, 255, 0.08);
          
          .menu-icon-container {
            i {
              transform: scale(1.08);
              text-shadow: 0 0 5px rgba(238, 186, 76, 0.5);
            }
            
            span {
              color: #f0d060;
            }
          }
        }
      }
      
      // 二级菜单标题垂直布局
      .el-submenu {
        .el-submenu__title {
          min-height: 70px;
          
          .menu-icon-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 10px 3px;
            
            i {
              margin-right: 0;
              margin-bottom: 5px;
              font-size: 20px;
            }
            
            span {
              display: block !important;
              font-size: 12px;
              line-height: 1.2;
              white-space: normal;
            }
          }
        }
      }
    }

    .bottom-container {
      padding: 16px 0;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      display: flex;
      justify-content: center;
      
      .bottom-buttons {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 0 20px;
        align-items: center;
        
        .avatar,
        .logout-btn {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #bfcbd9;
          transition: all 0.3s;
          border-radius: 4px;
          
          &:hover {
            color: #409EFF;
            background-color: rgba(255, 255, 255, 0.1);
          }
          
          i {
            font-size: 18px;
          }
        }
        
        .avatar {
          background-color: #1890ff;
          color: #fff;
          border-radius: 4px; /* 方形圆角 */
          font-weight: bold;
          font-size: 14px;
          
          &:hover {
            transform: none;
            /* 更暗的背景色+发光边框 */
            background-color: #0c4a8c; /* 更暗的蓝色 */
            color: #ffffff;
            box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.4);
          }
        }
      }
    }
  }
  
  // 主内容区域
  .main-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 80px; /* 为侧边栏留出空间 */
    display: flex;
    justify-content: center;
    background-color: #f0f2f5;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    height: 100vh; /* 确保容器高度为视口高度 */
    
    .content-wrapper {
      width: 100%;
      max-width: 1500px; /* Changed from 1600px */
      padding: 0; /* 去掉内边距，参考Welcome.vue的设置 */
      margin: 0 auto;
      box-sizing: border-box;
      min-height: 100%; /* 添加最小高度确保内容区域至少占满整个可视区域 */
      display: flex;
      flex-direction: column;
      flex: 1;
      
      @media (min-width: 1800px) {
        padding: 0; /* 在大屏幕上也没有内边距 */
      }
    }
  }
}

// 自定义二级菜单样式
.custom-submenu {
  position: relative;
  
  &.active-parent {
    background-color: rgba(255, 255, 255, 0.08);
    
    .menu-icon-container {
      color: #eeba4c !important;
      
      i {
        text-shadow: 0 0 8px rgba(238, 186, 76, 0.5);
      }
      
      // 添加左侧指示条
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 20%;
        height: 60%;
        width: 3px;
        background: linear-gradient(to bottom, #f0d060, #d4af37);
        border-radius: 0 2px 2px 0;
      }
    }
  }
  
  .menu-item-vertical {
    min-height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    
    .menu-icon-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0;
      height: 100%;
      color: #bfcbd9;
      transition: all 0.3s ease;
      
      &.active-menu {
        color: #eeba4c !important;
        
        i {
          text-shadow: 0 0 8px rgba(238, 186, 76, 0.5);
        }
      }
      
      i {
        margin-right: 0;
        margin-bottom: 5px;
        font-size: 20px;
        transition: all 0.3s ease;
      }
      
      span {
        display: block !important;
        font-size: 12px;
        line-height: 1.2;
        white-space: normal;
        transition: all 0.3s ease;
      }
    }
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.12);
      
      .menu-icon-container {
        color: #f0d060;
        
        i {
          transform: scale(1.08);
          text-shadow: 0 0 5px rgba(238, 186, 76, 0.5);
        }
      }
    }
  }
  
  .custom-submenu-dropdown {
    position: fixed; /* 使用fixed定位 */
    background-color: #1f2d3d;
    min-width: 160px;
    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    z-index: 9999;
    padding: 5px 0;
    margin-left: 0; /* 移除左边距，确保对齐 */
    animation: fadeIn 0.2s ease-out;
    
    @keyframes fadeIn {
      from { opacity: 0; transform: translateX(-10px); }
      to { opacity: 1; transform: translateX(0); }
    }
    
    &::before {
      content: '';
      position: absolute;
      left: -5px;
      top: 20px;
      border-top: 5px solid transparent;
      border-right: 5px solid #1f2d3d;
      border-bottom: 5px solid transparent;
    }
    
    .el-menu-item {
      height: 40px !important;
      line-height: 40px !important;
      width: 100%;
      text-align: left !important;
      padding: 0 15px !important;
      min-height: auto;
      font-size: 14px;
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      transition: all 0.2s ease;
      
      i {
        margin-right: 5px;
        color: #bfcbd9;
        text-align: left !important;
        transition: all 0.2s ease;
      }
      
      span {
        color: #bfcbd9;
        text-align: left !important;
        padding-left: 0 !important;
        margin-left: 0 !important;
        transition: all 0.2s ease;
      }
      
      &:hover {
        background-color: #283446 !important;
        transform: translateX(4px);
        
        i, span {
          color: #eeba4c !important;
        }
      }
    }
    
    .left-aligned-menu-item {
      padding: 0 !important;
      height: 40px !important;
      line-height: 40px !important;
      width: 100%;
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      cursor: pointer;
      
      .menu-item-content {
        display: flex;
        align-items: center;
        padding: 0 15px;
        width: 100%;
        height: 100%;
        
        i {
          margin-right: 5px;
          font-size: 16px;
          color: #bfcbd9;
          transition: all 0.2s ease;
        }
        
        span {
          font-size: 14px;
          color: #bfcbd9;
          transition: all 0.2s ease;
        }
      }

      &:hover {
        background-color: #283446 !important;
        transform: translateX(4px);
        
        .menu-item-content {
          i, span {
            color: #eeba4c !important;
          }
        }
      }
    }
  }
}

/* 博客链接样式 */
.blog-link-item {
  height: 40px !important;
  line-height: 40px !important;
  width: 100%;
  text-align: left !important;
  padding: 0 15px !important;
  min-height: auto;
  font-size: 14px;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  transition: all 0.2s ease;
  cursor: pointer;
  
  &:hover {
    background-color: #283446 !important;
    transform: translateX(4px);
    i, span {
      color: #eeba4c !important;
    }
  }
  
  .menu-item-content {
    display: flex;
    align-items: center;
    padding: 0 15px;
    width: 100%;
    height: 100%;
    
    i {
      margin-right: 5px;
      font-size: 16px;
      color: #bfcbd9;
    }
    
    span {
      font-size: 14px;
      color: #bfcbd9;
    }
  }
}

// 修改激活的菜单项样式
.el-menu-item.is-active {
  .menu-icon-container {
    color: #eeba4c !important; // 使用LOGO金色
    
    i {
      text-shadow: 0 0 8px rgba(238, 186, 76, 0.5);
      transform: scale(1.1);
    }
    
    // 添加左侧指示条
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 20%;
      height: 60%;
      width: 3px;
      background: linear-gradient(to bottom, #f0d060, #d4af37);
      border-radius: 0 2px 2px 0;
    }
  }
}
</style>

<style lang="scss">
// 全局样式，用于自定义tooltip
.custom-user-tooltip {
  .el-tooltip__popper {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 8px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
    padding: 0 !important;
    
    .el-tooltip__arrow::before {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
      border: 1px solid rgba(255, 255, 255, 0.2) !important;
    }
  }
  
  .user-tooltip-content {
    padding: 12px 16px;
    background: transparent;
    color: white;
    min-width: 120px;
    
    .username {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 8px;
      color: #ffffff;
      text-align: center;
      letter-spacing: 0.5px;
    }
    
    .score-info {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px 12px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 6px;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      
      &:hover {
        background: rgba(255, 255, 255, 0.25);
        transform: translateY(-1px);
        
        .click-hint {
          opacity: 1;
        }
      }
      
      .score-content {
        display: flex;
        align-items: center;
        gap: 6px;
      }
      
      .infinity-icon {
        font-size: 16px;
        line-height: 1;
        animation: sparkle 2s ease-in-out infinite alternate;
      }
      
      .score-value {
        font-size: 16px;
        font-weight: 700;
        color: #FFD700;
        text-shadow: 0 0 8px rgba(255, 215, 0, 0.4);
        line-height: 1;
        transform: translateY(2px);
        
        &.clickable {
          cursor: pointer;
        }
      }
      
      .score-label {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.9);
        font-weight: 500;
        line-height: 1;
        transform: translateY(4px);
      }
      
      .click-hint {
        position: absolute;
        bottom: -18px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 10px;
        color: rgba(255, 255, 255, 0.7);
        opacity: 0;
        transition: opacity 0.3s ease;
        white-space: nowrap;
      }
    }
  }
  
  @keyframes sparkle {
    0% {
      transform: scale(1);
      text-shadow: 0 0 8px rgba(255, 215, 0, 0.6);
    }
    100% {
      transform: scale(1.1);
      text-shadow: 0 0 12px rgba(255, 215, 0, 0.8), 0 0 20px rgba(255, 215, 0, 0.4);
    }
  }
}

/* 积分详情对话框专用样式 */
.score-dialog {
  border-radius: 8px !important;
  overflow: hidden !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
}

.score-dialog .el-dialog__header {
  padding: 16px 20px !important;
  background-color: #f5f7fa !important;
  border-bottom: 1px solid #e4e7ed !important;
  margin: 0 !important;
}

.score-dialog .el-dialog__title {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #303133 !important;
}

.score-dialog .el-dialog__body {
  padding: 20px 20px 10px !important;
  margin: 0 !important;
}

.score-dialog .el-dialog__footer {
  padding: 10px 20px 16px !important;
  border-top: 1px solid #f0f0f0 !important;
  margin: 0 !important;
}

/* 积分详情对话框内容样式 - 添加前缀限定作用域 */
.score-detail {
  padding: 10px 0;
  
  .user-info {
    text-align: center;
    margin-bottom: 20px;
    
    h3 {
      margin: 0;
      color: #303133;
      font-size: 18px;
    }
  }
  
  .score-breakdown {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 20px;
  }
  
  .score-item {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    text-align: center;
    border: 1px solid #e9ecef;
  }
  
  .score-label {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #606266;
    margin-bottom: 8px;
    
    i {
      margin-right: 6px;
      font-size: 16px;
      color: #409EFF;
    }
  }
  
  .score-value {
    font-size: 24px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 4px;
  }
  
  .score-desc {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }
  
  .total-score {
    background: linear-gradient(135deg, #409EFF, #67C23A);
    color: white;
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    margin-top: 20px;
    
    .total-label {
      font-size: 16px;
      margin-bottom: 8px;
      opacity: 0.9;
    }
    
    .total-value {
      font-size: 32px;
      font-weight: bold;
    }
  }
  
  /* 响应式设计 */
  @media (max-width: 768px) {
    .score-breakdown {
      grid-template-columns: 1fr;
      gap: 12px;
    }
    
    .score-item {
      padding: 12px;
    }
    
    .score-value {
      font-size: 20px;
    }
    
    .total-score .total-value {
      font-size: 28px;
    }
  }
}
</style> 
